// removed by extract-text-webpack-plugin
module.exports = {"leftNav":"TogglePageCard__leftNav___9B1rb","contentWithLeftNav":"TogglePageCard__contentWithLeftNav___28AoB","chapter":"TogglePageCard__chapter___27R6S","chapterHeader":"TogglePageCard__chapterHeader___2VQ0Z","chapterTitle":"TogglePageCard__chapterTitle___3soSK","chapterSubtitle":"TogglePageCard__chapterSubtitle___2RCtJ","nonIdeal":"TogglePageCard__nonIdeal___2C4Xe","noDataMessage":"TogglePageCard__noDataMessage___1drIh","togglePageCard":"TogglePageCard__togglePageCard___5VcAp","iconBar":"TogglePageCard__iconBar___1ZAWm","icon":"TogglePageCard__icon___3AhQ8"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/TogglePageCard.css
// module id = 1570
// module chunks = 0